module.exports = __webpack_public_path__ + "img/96-cents.b4928fbe.png";